import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './HomePage';
import CreatePage from './CreatePage';
import Nav from '../components/Nav';
import Workers from '../components/Workers';
import WorkersInDetail from '../components/WorkersInDetail';


export default function RouterPage() {

  return (
    <div className="main">
      <Nav />
      <div className="container">
          <Routes>
            <Route path="/home" element={<HomePage />} />
            <Route path="/create" element={<CreatePage />} />
            <Route path="/worker/:id" element={<WorkersInDetail/>} />
            <Route path="/home/:id" element={<Workers/>}/>
          </Routes>
      </div>
    </div>
  );
}
